export default __webpack_public_path__ + "static/media/about-vid-2.f3f27ece.mp4";